import { start } from "@anycable/turbo-stream"
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
import "bootstrap"
import "trix"

import cable from "./channels/cable"
import "./controllers"
import "./stream_actions"

ActiveStorage.start()
start(cable)
